<template>
  <div v-if="criteresRecherche">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('situation.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         class="mgt-20px"
                         :error="error"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="level mgt-20px columns">
      <div class="level-left column is-10">
        <div class="columns">
          <div class="column is-narrow">
            <b-field :label="$t('situation.filtres.periodeComptable')"
                     custom-class="has-text-default">
              <date-picker :dates="dates"
                           :updateEndDateAtChangeStartDate="false"/>
            </b-field>
          </div>
          <div class="column is-narrow">
            <b-field :label="$t('situation.filtres.dateSituation')"
                     custom-class="has-text-default">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            icon="calendar-today"
                            v-model="criteresRecherche.dateSituation"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-3" v-if="agencesSelectionnees.length > 1">
            <b-field :label="$t('situation.filtres.agence')"
                     custom-class="has-text-default">
              <qd-taginput v-if="agenceTags"
                          :ellipsis="true"
                          icon="magnify"
                          v-model="criteresRecherche.agences"
                          :data="agenceTags"
                          type="is-primary"
                          autocomplete
                          open-on-focus
                          field="libelleAgence"
                          @typing="getFilteredAgenceTags"
                          @input="getAgenceTag">
              </qd-taginput>
            </b-field>
          </div>
          <div class="column is-narrow bfieldWhitoutLabel">
            <div class="buttons">
              <button class="button is-addOrEdit" @click="actualiserCalcul()">
                {{ $t('situation.actions.actualiser') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="level-right column is-2">
        <a ref="lienDownload"></a>
        <div class="columns justify-content-flex-end">
          <div class="column is-narrow bfieldWhitoutLabel">
            <exportExcelButton
              :perm="constantes.SITUATION.exporter"
              :action="exportExcel"/>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <table class="VueTables__table table is-bordered
      is-fullwidth is-striped thWithTextColorLink">
        <thead class="has-text-link-important">
        <th colspan="2"></th>
        <th colspan="2" class="has-text-link-important">{{ $t('situation.tab.depense') }}</th>
        <th colspan="2" class="has-text-link-important">{{ $t('situation.tab.recette') }}</th>
        </thead>
        <thead>
        <th>{{ $t('situation.tab.tva') }}</th>
        <th>{{ $t('situation.tab.supportCommercial') }}</th>
        <th>{{ $t('situation.tab.factureNonParvenues') }}</th>
        <th>{{ $t('situation.tab.chargeConstate') }}</th>
        <th>{{ $t('situation.tab.factureEmettre') }}</th>
        <th>{{ $t('situation.tab.produitConstate') }}</th>
        </thead>
        <tbody>
        <template v-for="tauxTva in getListTauxTva">
          <tr v-for="situationLigne in getSituationLignesWithTauxTva(tauxTva)"
              :key="situationLigne.key">
            <td> {{ situationLigne.tauxTva }} %</td>
            <td> {{ situationLigne.libelleSupportCommercial }} </td>
            <td class="has-text-right"> {{ situationLigne.montantCumulFNP | formatDevise }} </td>
            <td class="has-text-right"> {{ situationLigne.montantCumulCCA | formatDevise }} </td>
            <td class="has-text-right"> {{ situationLigne.montantCumulFAE | formatDevise }} </td>
            <td class="has-text-right"> {{ situationLigne.montantCumulPCA | formatDevise }} </td>
          </tr>
          <tr v-if="getListTauxTva.length > 1" :key="tauxTva"
              class="has-text-weight-bold">
            <td>
              <div class="has-text-link">
              {{ $t('situation.tab.totalTva', { TauxTva: tauxTva }) }}
              </div>
            </td>
            <td></td>
            <td>
              <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulFNP', tauxTva) | formatDevise }}
              </div>
            </td>
            <td>
              <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulCCA', tauxTva) | formatDevise }}
              </div>
            </td>
            <td>
              <div class="has-text-link has-text-right">
                {{ getTotalWithKeyAndTauxTva('montantCumulFAE', tauxTva) | formatDevise }}
              </div>
            </td>
            <td>
              <div class="has-text-link has-text-right">
                {{ getTotalWithKeyAndTauxTva('montantCumulPCA', tauxTva) | formatDevise }}
              </div>
            </td>
          </tr>
        </template>
        <tr class="has-text-weight-bold" v-if="getListTauxTva.length > 0">
          <td>
            <div class="has-text-link">
              {{ $t('situation.tab.total') }}
            </div>
          </td>
          <td></td>
          <td>
            <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulFNP', null) | formatDevise }}
            </div>
          </td>
          <td>
            <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulCCA', null) | formatDevise }}
            </div>
          </td>
          <td>
            <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulFAE', null) | formatDevise }}
            </div>
          </td>
          <td>
            <div class="has-text-link has-text-right">
              {{ getTotalWithKeyAndTauxTva('montantCumulPCA', null) | formatDevise }}
            </div>
          </td>
        </tr>
        <tr v-else>
          <td colspan="6">{{ $t('situation.tab.noRslt')}} </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { SITUATION } from '@/configuration/compta/permissionsComptaConf';
import messageErreur from '@/services/general/messageErreur';
import generercriteresRechercheSituation from '@/services/compta/situation/genererCritereRechercheSituation';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import formatDateIso from '@/services/general/formatIsoDate';
import cumul from '@/api/compta/situation';
import validation from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import translate from '@/services/compta/situation/translate';
import messageSuccess from '@/services/general/messageSucces';
import exportExcel from '@/api/exportExcel/index';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import TYPE_DONNEE_SITUATION from '@/configuration/compta/situationConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import datePicker from '@/components/general/datePicker';
import validationSituation from '@/services/compta/situation/validationSituation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      criteresRecherche: null,
      unsubscribeValue: null,
      agenceTags: null,
      listeAgenceBase: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      constantes: {
        SITUATION,
      },
      dates: {
        dateDebut: null,
        dateFin: null,
      },
      cumulSituation: null,
    };
  },
  components: {
    breadcrumb,
    datePicker,
    errorMsgComponent,
    exportExcelButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    getListTauxTva() {
      if (!this.cumulSituation || this.cumulSituation.situationLignes.length === 0) return [];
      const tauxTva = [...new Set(this.cumulSituation.situationLignes
        .map(situtationLigne => situtationLigne.tauxTva))];
      return tauxTva.sort();
    },
    breadcrumb() {
      return [
        { title: this.$t('situation.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('situation.breadcrumb.situation'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    getTotalWithKeyAndTauxTva(key, tauxTva) {
      return this.getSituationLignesWithTauxTva(tauxTva)
        .map((situationligne) => { return situationligne[key]; })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
    },
    getSituationLignesWithTauxTva(tauxTva) {
      if (tauxTva === null) return this.cumulSituation.situationLignes;
      const situationsLignes = this.cumulSituation.situationLignes.filter((situationligne) => {
        return situationligne.tauxTva === tauxTva;
      });
      situationsLignes.sort((a, b) => {
        return a.libelleSupportCommercial.localeCompare(b.libelleSupportCommercial);
      });
      return situationsLignes;
    },
    getAgenceTag() {
      this.agenceTags = this.listeAgenceBase.filter((agence) => {
        return !this.criteresRecherche.agences.map(a => a.agenceId).includes(agence.agenceId);
      });
    },
    getFilteredAgenceTags(text) {
      this.getAgenceTag();
      this.agenceTags = this.agenceTags.filter((agence) => {
        return agence.libelleAgence.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    updateAgences() {
      this.criteresRecherche.agences = [];
      if (this.criteresRecherche.societeId !== this.societeActiveId) {
        this.criteresRecherche.societeId = this.societeActiveId;
      }
      this.listeAgenceBase = cloneDeep(this.agencesSelectionnees);
      this.getAgenceTag();
    },
    async exportExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const criteresRecherche = cloneDeep(this.criteresRecherche);
        criteresRecherche.dateDebut = this.dates.dateDebut;
        criteresRecherche.dateFin = this.dates.dateFin;
        criteresRecherche.agencesId = criteresRecherche.agences.map((agence) => {
          return agence.agenceId;
        });
        delete criteresRecherche.agences;
        if (!criteresRecherche.dateSituation) {
          messageErreur(this.$i18n, this.$i18n.t('situation.messages.error.exportExcel'));
          loadingComponent.close();
          return;
        }
        criteresRecherche.dateDebut = formatDateIso(criteresRecherche.dateDebut);
        criteresRecherche.dateFin = formatDateIso(criteresRecherche.dateFin);
        criteresRecherche.dateSituation = formatDateIso(criteresRecherche.dateSituation);
        const filtres = {
          limit: NO_PAGINATION,
          query: criteresRecherche,
        };
        const response = await exportExcel({
          typeDonnee: TYPE_DONNEE_SITUATION,
          filtres: generalTransformer(filtres),
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        if (response) {
          validationSituation({ data: response }, this.messages);
          validation(this.$i18n, { data: response }, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async actualiserCalcul() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const criteresRecherche = cloneDeep(this.criteresRecherche);
        criteresRecherche.agencesId = criteresRecherche.agences.map((agence) => {
          return agence.agenceId;
        });
        criteresRecherche.dateDebut = formatDateIso(this.dates.dateDebut);
        criteresRecherche.dateFin = formatDateIso(this.dates.dateFin);
        delete criteresRecherche.agences;
        criteresRecherche.dateSituation = formatDateIso(criteresRecherche.dateSituation);
        this.cumulSituation = (await cumul(criteresRecherche)).data.result;
        messageSuccess(this.$i18n.t('situation.messages.success.calculDone'));
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationSituation(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.criteresRecherche = generercriteresRechercheSituation(
        this.societeActiveId,
      );
      this.listeAgenceBase = cloneDeep(this.agencesSelectionnees);
      this.getAgenceTag();
      this.setInformationPage(this.$t('pageCompta.situation.liste'));
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgences, null);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
